import { useAtom, useAtomValue } from "jotai";
import { useTransformColumns } from "library/utils/useTransformColumns";
import { useTransformColumnsSizing } from "library/utils/useTransformColumnsSizing";
import { useEffect, useState } from "react";
import { useGetOffers } from "state/queries/useGetOffers";
import {
  areAnyColumnsFilteredState,
  offersPageColumnsState,
  offersPageRowsState,
  offersPageSearchState,
  offersPageSkipState,
  offersPageSortState,
  offersPageTopState,
} from "store/OffersPageStore";
import ListPageTable from "../../components/ListPageTable/ListPageTable";
import { defaultCols } from "./columns";
import { ColumnOptions } from "./components/ColumnOptions";
import { ColumnOptionsButton } from "@greco/components";
import { useTranslation } from "react-i18next";
import { Navigation } from "components/Navigation/Navigation";

const OfferList = () => {
  const searchAtom = useAtom(offersPageSearchState);
  const skipAtom = useAtom(offersPageSkipState);
  const topAtom = useAtom(offersPageTopState);
  const columnsAtom = useAtom(offersPageColumnsState);
  const sortAtom = useAtom(offersPageSortState);
  const [rows, setRows] = useAtom(offersPageRowsState);
  const [total, setTotal] = useState(0);

  const [isColumnOptionsOpen, setIsColumnOptionsOpen] = useState(false);
  const areAnyColumnsFiltered = useAtomValue(areAnyColumnsFilteredState);
  const { t } = useTranslation();
  useEffect(() => {
    columnsAtom[1](defaultCols);
  }, [columnsAtom]);

  const transformedColumns = useTransformColumns(columnsAtom[0]);
  const transformedColumnsSizing = useTransformColumnsSizing(columnsAtom[0]);

  const { data: odataResponse, isLoading } = useGetOffers({
    skip: skipAtom[0],
    top: topAtom[0],
    sort: sortAtom[0],
    columns: columnsAtom[0],
    search: searchAtom[0],
    enabled: true,
  });
  useEffect(() => {
    if (odataResponse) {
      setRows((prevRows) => [
        ...prevRows,
        ...(Array.isArray(odataResponse?.value) ? odataResponse.value : []),
      ]);
      setTotal(odataResponse?.["@odata.count"]);
    }
  }, [odataResponse, setRows]);
  if (!transformedColumns) return null;
  const columnOptions = (
    <>
      <ColumnOptionsButton
        t={t as any}
        isActive={areAnyColumnsFiltered}
        onClick={() => {
          setIsColumnOptionsOpen(true);
        }}
      />
      <ColumnOptions
        isOpen={isColumnOptionsOpen}
        closePanel={() => {
          setIsColumnOptionsOpen(false);
        }}
      />
    </>
  );
  return (
    <div>
      <Navigation columnOptions={columnOptions} displaySearch displayReload />
      {/* <ListPageTable
        columns={transformedColumns}
        columnSizingOptions={transformedColumnsSizing}
        data={rows}
        total={total}
        isLoading={isLoading}
        states={{
          skip: offersPageSkipState,
          top: offersPageTopState,
          search: offersPageSearchState,
          sort: offersPageSortState,
        }}
      /> */}
    </div>
  );
};

export default OfferList;
